import React, { createContext, PropsWithChildren, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { i18n } from "i18next"
import i18nInstance, { initOptions } from "../../i18n";


const createI18nInstance = (
    translations: { [key: string]: any } = {},
    keySeparator?: string | false,
    lang?: any
) => {
    const newInstance = i18nInstance.createInstance();

    newInstance.init({
        ...initOptions,
        keySeparator: keySeparator,
        lng: lang
    });

    if (translations) {
        const keys = Object.keys(translations);
        keys.forEach((key) => {
            newInstance.addResourceBundle(key, "schema", translations[key]);
        });
    }


    return newInstance

}

const context = createContext<i18n>(i18nInstance);
const { Provider } = context;
export const useSchemaI18NInstance = () => useContext(context);


interface SchemaI18NProviderProps {
    translations?: { [key: string]: any };
    keySeparator?: string | false
};

export const SchemaI18NProvider: React.FC<PropsWithChildren<SchemaI18NProviderProps>> = ({
    translations = {},
    keySeparator = ".", // old schemas used this as separator, so this is important fallback
    children
}) => {
    const { i18n: appInstance } = useTranslation();
    const currentLanguage = appInstance.language;

    const instance = useMemo(() => {
        return createI18nInstance(translations, keySeparator, currentLanguage);
    },
        [translations, keySeparator, currentLanguage]
    )

    return (
        <Provider value={instance}>
            {children}
        </Provider>
    )
}